import React, { BaseSyntheticEvent, useState } from 'react';

import { PasswordInput } from '../../../components';
import { BlueButton, StyledTextFieldWrapper } from '../../../components/BlueTheme';
import { StyledCheckbox } from '../../../components/BlueTheme/StyledCheckbox/styled';
import StepHeader from '../../../components/MFA/StepHeader/StepHeader';
import { PasswordErrors } from '../../../models';
import validatePassword from '../../../utils/validatePassword';
import { AGREEMENT_TEXT, REPRESENTATIVE_TEXT } from '../constants';
import { FormState, UserData } from '../types';
import { isSubmitDisabled } from '../utils';
import { PasswordValidationListWrapper, StyledBottomPart, StyledButtonWrapper, StyledInputSection } from './styled';
import UserInfo from './UserInfo';

type Props = {
  userData?: UserData | undefined;
  loading: boolean;
  onSetPassword: (password: string) => void;
  passwordStep: boolean;
};
const SetPasswordStep = ({ userData, loading, onSetPassword, passwordStep }: Props): JSX.Element => {
  const [errors, setErrors] = useState<PasswordErrors | undefined>();

  const [form, setForm] = useState<FormState>({
    password: '',
    repeatPassword: '',
    representative: false,
    agreement: false,
  });

  const validationForm = ({ password, repeatPassword }: FormState): void => {
    const errorsObject = validatePassword(password, repeatPassword);

    setErrors(errorsObject);
  };

  const onChange = ({ target: { name, type, checked, value } }: BaseSyntheticEvent): void => {
    const formValue = type === 'checkbox' ? checked : value;
    const newFormValues = { ...form, [name]: formValue };

    setForm(newFormValues);
    validationForm(newFormValues);
  };

  const clickGetStarted = (): void => {
    const { password } = form;
    onSetPassword(password);
  };

  return (
    <>
      {!passwordStep ? (
        <StepHeader subTitle="Welcome! To finish setting up your account, create a password below. You can edit your account details later." />
      ) : (
        <StepHeader subTitle="Welcome back! Enter a new password below to access your account." />
      )}
      <UserInfo name={`${userData?.firstName || ''} ${userData?.lastName || ''}`} email={userData?.email} />
      <StyledInputSection>
        <StyledTextFieldWrapper>
          <PasswordInput
            name="password"
            labelText="Password"
            placeholder="Enter your password"
            onChange={onChange}
            dataTestId="fieldPassword"
          />
        </StyledTextFieldWrapper>
        <StyledTextFieldWrapper>
          <PasswordInput
            name="repeatPassword"
            labelText="Confirm Password"
            placeholder="Enter your password"
            onChange={onChange}
            dataTestId="fieldRepeatPassword"
          />
        </StyledTextFieldWrapper>
        <PasswordValidationListWrapper errors={errors} />
      </StyledInputSection>
      <StyledBottomPart>
        <StyledCheckbox
          name="representative"
          onChange={onChange}
          label={REPRESENTATIVE_TEXT}
          data-testid="checkboxRepresentative"
        />
        <StyledCheckbox name="agreement" onChange={onChange} label={AGREEMENT_TEXT} data-testid="checkboxAgreement" />
      </StyledBottomPart>
      <StyledButtonWrapper>
        <BlueButton
          name="Continue"
          data-testid="buttonGetStarted"
          disabled={isSubmitDisabled(form, errors) || loading}
          isLoading={loading}
          onClick={clickGetStarted}
        />
      </StyledButtonWrapper>
    </>
  );
};

export default SetPasswordStep;
